import type { Remote } from 'codesearch-backend'

/*
  the three url shapes worth knowing. forgejo is the fallback for anything
  self-hosted: gitea and forgejo agree on these paths, and between them they are
  most of what isn't github or gitlab.

  ref: https://docs.github.com/en/repositories, https://forgejo.org/docs/latest/
*/
export function commitUrl(remote: Remote | null | undefined, sha: string): string | null {
  if (!remote) return null
  switch (remote.kind) {
    case 'gitlab':
      return `${remote.base}/-/commit/${sha}`
    case 'github':
    case 'forgejo':
      return `${remote.base}/commit/${sha}`
  }
}

export function fileUrl(
  remote: Remote | null | undefined,
  params: { gitRef: string, path: string, line?: number },
): string | null {
  if (!remote) return null
  const anchor = params.line ? `#L${params.line}` : ''
  const ref = encodeURIComponent(params.gitRef)
  const path = params.path.split('/').map(encodeURIComponent).join('/')

  switch (remote.kind) {
    case 'github':
      return `${remote.base}/blob/${ref}/${path}${anchor}`
    case 'gitlab':
      return `${remote.base}/-/blob/${ref}/${path}${anchor}`
    case 'forgejo':
      return `${remote.base}/src/commit/${ref}/${path}${anchor}`
  }
}

/** what to call the button that opens the file over there */
export function forgeName(remote: Remote | null | undefined): string {
  if (!remote) return 'remote'
  try {
    return new URL(remote.base).hostname
  } catch {
    return 'remote'
  }
}
